import React, { Component } from 'react';
import classnames from 'classnames';

class AgentTab extends Component {

  tabType = "AGENT";

  thisTabClicked = (e) => {
    const { tabClicked } = this.props;
    tabClicked(this.tabType);
  }

  render() {
    
    const { thisTabClicked } = this;
    const { activeTabType } = this.props;

    const agentTabClass = classnames({
      "col-sm" : true,
      "list-tab" : true,
      "last-tab" : this.props.isLastTab,
      "active" : activeTabType === this.tabType ? true : false
    });

    return (
      <div className={agentTabClass}
      onClick={thisTabClicked}>
        에이전트
      </div>
    );
  }
}

export default AgentTab;